import { render, staticRenderFns } from "./DocumentsGridBlock.vue?vue&type=template&id=67411a74&scoped=true"
import script from "./DocumentsGridBlock.vue?vue&type=script&lang=js"
export * from "./DocumentsGridBlock.vue?vue&type=script&lang=js"
import style0 from "./DocumentsGridBlock.vue?vue&type=style&index=0&id=67411a74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67411a74",
  null
  
)

export default component.exports